// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.message-display-container {
  background-color: #f0f0f5; /* Light gray background similar to iOS */
  min-height: 96vh; 
  height: 98vh;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  padding-bottom: 20px;
  width: 100%;
}


.back-buttonMsg {
  background: none;
  border: none;
  color: #007aff; /* iOS blue for a consistent look */
  font-size: 28px;
  cursor: pointer;
  /* padding: 10px;
  margin-right: 10px; */
}

.incomingmsg { 
    display: flex;
    /* padding-left: 10px; */
    text-align: left;
}

.message-header {
  display: flex;
  align-items: center;
  padding: 10px;
  background-color: #fff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  width: 100%;
  margin-bottom: 10px;
}

.message-to {
  color: #007aff; /* iOS blue for links and buttons */
  font-weight: bold;
  width: 80%;
  max-width: 95%;
  font-size: 18px;
}

.message-contentSent {
  width: 100%;
  align-self: flex-end; /* Align to the right for the sender */
}



.message-contentForSentScroll {
  width: 100%;
  flex: 1 1; /* Makes it fill the space between header and input */
  display: flex;
  flex-direction: column;
  justify-content: flex-end; /* Aligns messages to the bottom */
}

.scrollable-messagesForSent {
  display: inline-flex;
  flex-direction: column;
  overflow-y: auto; /* Enables vertical scrolling */
  max-height: calc(87vh - 20px); /* Adjust the value as needed based on your layout */
  margin-bottom: 10vh;
  scrollbar-width: none;
  /*  max-width: 95vw;add media query later*/
  width: 97%;
  overflow-x: hidden;
  
}

.message-body-incoming {
  align-self: flex-start; /* Align incoming messages to the left */
  background-color: #63ce85 !important; /* Different background for distinction */
  margin-right: 5em !important;
}

.message-body-outgoing {
  align-self: flex-end; /* Align outgoing messages to the right */
  background-color: #007aff;
  /* margin-left: 15em !important; */
}



.message-bodyResponse {
  background-color: #63ce85; /* iOS message bubble color for outgoing messages */
  color: white;
  border-radius: 18px;
  padding: 5px 7px;
  margin-left: 5px S!important;
  margin-bottom: 4px; /* Small gap between the message and the timestamp */
  word-wrap: break-word;
  font-size: 18px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.message-body {
  background-color: #007aff; /* iOS message bubble color for outgoing messages */
  color: white;
  border-radius: 18px;
  padding: 3px 9px;
  max-width: 65%;
  /* width: 55%; */
  margin-bottom: 4px; /* Small gap between the message and the timestamp */
  word-wrap: break-word;
  font-size: 18px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}


/* SentMessageDisplay.css */

.message-input-container {
display: flex;
width: 95%;
padding: 10px;
position: absolute;
top: 91%;
}

.new-message-input {
flex-grow: 1;
border-radius: 18px;
padding: 10px;
margin-right: 10px;
border: 1px solid #ccc; /* or another color that matches iOS style */
font-size: 16px;
}

.send-new-message-button {
background-color: #007aff; /* iOS blue */
color: white;
border: none;
border-radius: 18px;
padding: 10px 20px;
font-size: 16px;
}


.message-time {
  color: #999;
  font-size: 12px;
  font-weight: 600;
  text-align: right;
  padding-right: 20px; /* Aligns with the right edge of the message bubble */
}


.message-body-incoming {
  position: relative;
  background-color: #63ce85; /* Your incoming message color */
  border-radius: 18px;
  padding: 10px 20px;
  max-width: 80%;
  margin: 5px 0;
  font-size: 16px;
  color: white;
  align-self: flex-start;
}

.message-body-incoming::after {
  content: '';
  position: absolute;
  left: 1px; /* Adjust this value to move the tail left or right */
  bottom: -2px; /* Adjust this value to move the tail up or down */
  border-style: solid;
  border-width: 15px 15px 15px 0; /* Adjust size of the tail */
  border-color: #63ce85 transparent transparent ; /* Tail color */
  transform: translateY(50%);
  z-index: 1;
}


.message-body-outgoing {
  position: relative;
  background-color: #007aff; /* Your incoming message color */
  border-radius: 18px;
  padding: 10px 20px;
  max-width: 80%;
  margin: 5px 0;
  font-size: 16px;
  color: white;
  align-self: flex-end;
}

.message-body-outgoing::after {
  content: '';
  position: absolute;
  right: -1px; /* Adjust this value to move the tail left or right */
  bottom: 6px; /* Adjust this value to move the tail up or down */
  border-style: solid;
  border-width: 12px 12px 12px 0; /* Adjust size of the tail */
  border-color: transparent #007aff transparent transparent; /* Tail color */
  transform: translateY(50%);
  z-index: 1;
}

`, "",{"version":3,"sources":["webpack://./src/components/css/SentMessageDisplay.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB,EAAE,yCAAyC;EACpE,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,mBAAmB;EACnB,oBAAoB;EACpB,WAAW;AACb;;;AAGA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc,EAAE,mCAAmC;EACnD,eAAe;EACf,eAAe;EACf;uBACqB;AACvB;;AAEA;IACI,aAAa;IACb,wBAAwB;IACxB,gBAAgB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,wCAAwC;EACxC,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,cAAc,EAAE,mCAAmC;EACnD,iBAAiB;EACjB,UAAU;EACV,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,oBAAoB,EAAE,sCAAsC;AAC9D;;;;AAIA;EACE,WAAW;EACX,SAAO,EAAE,qDAAqD;EAC9D,aAAa;EACb,sBAAsB;EACtB,yBAAyB,EAAE,kCAAkC;AAC/D;;AAEA;EACE,oBAAoB;EACpB,sBAAsB;EACtB,gBAAgB,EAAE,+BAA+B;EACjD,6BAA6B,EAAE,oDAAoD;EACnF,mBAAmB;EACnB,qBAAqB;EACrB,0CAA0C;EAC1C,UAAU;EACV,kBAAkB;;AAEpB;;AAEA;EACE,sBAAsB,EAAE,wCAAwC;EAChE,oCAAoC,EAAE,yCAAyC;EAC/E,4BAA4B;AAC9B;;AAEA;EACE,oBAAoB,EAAE,yCAAyC;EAC/D,yBAAyB;EACzB,kCAAkC;AACpC;;;;AAIA;EACE,yBAAyB,EAAE,mDAAmD;EAC9E,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,4BAA4B;EAC5B,kBAAkB,EAAE,oDAAoD;EACxE,qBAAqB;EACrB,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB,EAAE,mDAAmD;EAC9E,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,kBAAkB,EAAE,oDAAoD;EACxE,qBAAqB;EACrB,eAAe;EACf,wCAAwC;AAC1C;;;AAGA,2BAA2B;;AAE3B;AACA,aAAa;AACb,UAAU;AACV,aAAa;AACb,kBAAkB;AAClB,QAAQ;AACR;;AAEA;AACA,YAAY;AACZ,mBAAmB;AACnB,aAAa;AACb,kBAAkB;AAClB,sBAAsB,EAAE,4CAA4C;AACpE,eAAe;AACf;;AAEA;AACA,yBAAyB,EAAE,aAAa;AACxC,YAAY;AACZ,YAAY;AACZ,mBAAmB;AACnB,kBAAkB;AAClB,eAAe;AACf;;;AAGA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB,EAAE,qDAAqD;AAC5E;;;AAGA;EACE,kBAAkB;EAClB,yBAAyB,EAAE,gCAAgC;EAC3D,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,eAAe;EACf,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS,EAAE,qDAAqD;EAChE,YAAY,EAAE,kDAAkD;EAChE,mBAAmB;EACnB,8BAA8B,EAAE,4BAA4B;EAC5D,8CAA8C,EAAE,eAAe;EAC/D,0BAA0B;EAC1B,UAAU;AACZ;;;AAGA;EACE,kBAAkB;EAClB,yBAAyB,EAAE,gCAAgC;EAC3D,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,eAAe;EACf,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW,EAAE,qDAAqD;EAClE,WAAW,EAAE,kDAAkD;EAC/D,mBAAmB;EACnB,8BAA8B,EAAE,4BAA4B;EAC5D,yDAAyD,EAAE,eAAe;EAC1E,0BAA0B;EAC1B,UAAU;AACZ","sourcesContent":[".message-display-container {\n  background-color: #f0f0f5; /* Light gray background similar to iOS */\n  min-height: 96vh; \n  height: 98vh;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: center;\n  padding-bottom: 20px;\n  width: 100%;\n}\n\n\n.back-buttonMsg {\n  background: none;\n  border: none;\n  color: #007aff; /* iOS blue for a consistent look */\n  font-size: 28px;\n  cursor: pointer;\n  /* padding: 10px;\n  margin-right: 10px; */\n}\n\n.incomingmsg { \n    display: flex;\n    /* padding-left: 10px; */\n    text-align: left;\n}\n\n.message-header {\n  display: flex;\n  align-items: center;\n  padding: 10px;\n  background-color: #fff;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  width: 100%;\n  margin-bottom: 10px;\n}\n\n.message-to {\n  color: #007aff; /* iOS blue for links and buttons */\n  font-weight: bold;\n  width: 80%;\n  max-width: 95%;\n  font-size: 18px;\n}\n\n.message-contentSent {\n  width: 100%;\n  align-self: flex-end; /* Align to the right for the sender */\n}\n\n\n\n.message-contentForSentScroll {\n  width: 100%;\n  flex: 1; /* Makes it fill the space between header and input */\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end; /* Aligns messages to the bottom */\n}\n\n.scrollable-messagesForSent {\n  display: inline-flex;\n  flex-direction: column;\n  overflow-y: auto; /* Enables vertical scrolling */\n  max-height: calc(87vh - 20px); /* Adjust the value as needed based on your layout */\n  margin-bottom: 10vh;\n  scrollbar-width: none;\n  /*  max-width: 95vw;add media query later*/\n  width: 97%;\n  overflow-x: hidden;\n  \n}\n\n.message-body-incoming {\n  align-self: flex-start; /* Align incoming messages to the left */\n  background-color: #63ce85 !important; /* Different background for distinction */\n  margin-right: 5em !important;\n}\n\n.message-body-outgoing {\n  align-self: flex-end; /* Align outgoing messages to the right */\n  background-color: #007aff;\n  /* margin-left: 15em !important; */\n}\n\n\n\n.message-bodyResponse {\n  background-color: #63ce85; /* iOS message bubble color for outgoing messages */\n  color: white;\n  border-radius: 18px;\n  padding: 5px 7px;\n  margin-left: 5px S!important;\n  margin-bottom: 4px; /* Small gap between the message and the timestamp */\n  word-wrap: break-word;\n  font-size: 18px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.message-body {\n  background-color: #007aff; /* iOS message bubble color for outgoing messages */\n  color: white;\n  border-radius: 18px;\n  padding: 3px 9px;\n  max-width: 65%;\n  /* width: 55%; */\n  margin-bottom: 4px; /* Small gap between the message and the timestamp */\n  word-wrap: break-word;\n  font-size: 18px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n\n/* SentMessageDisplay.css */\n\n.message-input-container {\ndisplay: flex;\nwidth: 95%;\npadding: 10px;\nposition: absolute;\ntop: 91%;\n}\n\n.new-message-input {\nflex-grow: 1;\nborder-radius: 18px;\npadding: 10px;\nmargin-right: 10px;\nborder: 1px solid #ccc; /* or another color that matches iOS style */\nfont-size: 16px;\n}\n\n.send-new-message-button {\nbackground-color: #007aff; /* iOS blue */\ncolor: white;\nborder: none;\nborder-radius: 18px;\npadding: 10px 20px;\nfont-size: 16px;\n}\n\n\n.message-time {\n  color: #999;\n  font-size: 12px;\n  font-weight: 600;\n  text-align: right;\n  padding-right: 20px; /* Aligns with the right edge of the message bubble */\n}\n\n\n.message-body-incoming {\n  position: relative;\n  background-color: #63ce85; /* Your incoming message color */\n  border-radius: 18px;\n  padding: 10px 20px;\n  max-width: 80%;\n  margin: 5px 0;\n  font-size: 16px;\n  color: white;\n  align-self: flex-start;\n}\n\n.message-body-incoming::after {\n  content: '';\n  position: absolute;\n  left: 1px; /* Adjust this value to move the tail left or right */\n  bottom: -2px; /* Adjust this value to move the tail up or down */\n  border-style: solid;\n  border-width: 15px 15px 15px 0; /* Adjust size of the tail */\n  border-color: #63ce85 transparent transparent ; /* Tail color */\n  transform: translateY(50%);\n  z-index: 1;\n}\n\n\n.message-body-outgoing {\n  position: relative;\n  background-color: #007aff; /* Your incoming message color */\n  border-radius: 18px;\n  padding: 10px 20px;\n  max-width: 80%;\n  margin: 5px 0;\n  font-size: 16px;\n  color: white;\n  align-self: flex-end;\n}\n\n.message-body-outgoing::after {\n  content: '';\n  position: absolute;\n  right: -1px; /* Adjust this value to move the tail left or right */\n  bottom: 6px; /* Adjust this value to move the tail up or down */\n  border-style: solid;\n  border-width: 12px 12px 12px 0; /* Adjust size of the tail */\n  border-color: transparent #007aff transparent transparent; /* Tail color */\n  transform: translateY(50%);\n  z-index: 1;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
